const accordions = document.querySelectorAll('.hoox-accordion');

if (accordions && accordions.length) {
    accordions.forEach(accordion => {
        const accordionBtn = accordion.querySelector('.hoox-accordion__header');
        const panel = accordion.querySelector('.hoox-accordion__panel');
        accordionBtn.addEventListener('click', () => {
            accordion.classList.toggle('show-text');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            !accordion.classList.contains('show-text') ? panel.style.maxHeight = null : panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
        });
    })
}